import { EditorState, Modifier, SelectionState } from 'draft-js'
import { linkify } from '@disco/utils/links'

const linkifyEditorState: (editorState: EditorState) => EditorState =
  editorState => {
    const contentState = editorState.getCurrentContent()
    const blocks = contentState.getBlockMap()
    const originalSelection = editorState.getSelection()
    let newContentState = contentState
    blocks.forEach(block => {
      const plainText = block.getText()

      const addEntityToLink = ({
        index: start,
        lastIndex: end,
        schema,
        url,
      }) => {
        const existingEntityKey = block.getEntityAt(start)

        if (existingEntityKey) {
          // avoid manipulation in case the link already has an entity
          const entity = contentState.getEntity(existingEntityKey)

          if (entity && entity.get('type').toLowerCase() === 'link') {
            return
          }
        }

        const selection = SelectionState.createEmpty(block.getKey())
          .set('anchorOffset', start)
          .set('focusOffset', end)
        const linkText = plainText.substring(start, end)
        const entity =
          schema !== 'mailto:'
            ? {
                url,
                target: '_blank',
              }
            : {
                url,
              }
        newContentState = newContentState.createEntity(
          'LINK',
          'IMMUTABLE',
          entity,
        )
        const entityKey = newContentState.getLastCreatedEntityKey()
        newContentState = Modifier.replaceText(
          newContentState,
          selection,
          linkText,
          null,
          entityKey,
        )
      }

      findLinks(block, addEntityToLink)
    })

    if (!newContentState.equals(contentState)) {
      const linkedEditorState = EditorState.push(
        editorState,
        newContentState,
        'convert-to-links',
      )
      // we must preserve selection state
      return EditorState.set(linkedEditorState, {
        selection: originalSelection,
      })
    }

    return editorState
  }

const findLinks = (contentBlock, callback) => {
  const links = linkify.match(contentBlock.get('text'))

  if (typeof links !== 'undefined' && links !== null) {
    for (let i = 0; i < links.length; i++) {
      callback(links[i])
    }
  }
}

export default linkifyEditorState
